import React from 'react';

import {
  ExecutionResult,
} from '../components';

export function fmtExecutionResult(value) {
  return <ExecutionResult value={value}/>;
}
